module.exports = __webpack_public_path__ + "img/whychose1.20850d31.svg";